import React from 'react';
import { Close } from '@one-thd/sui-icons';
import { Card, CardBody, CardTitle } from '@one-thd/sui-atomic-components';
import { StoreOverlayHours } from './StoreOverlayHours/StoreOverlayHours';
import { storeShape } from '../storeShape';

export const StoreOverlay = ({ store }) => {
  if (!store) return null;

  const {
    address, name, services, storeDetailsPageLink, storeId
  } = store;

  const {
    city,
    postalCode,
    state,
    street
  } = address || {};

  const {
    loadNGo,
    propane,
    toolRental,
    penske,
    keyCutting,
    wiFi,
    applianceShowroom,
    expandedFlooringShowroom,
    largeEquipment,
    kitchenShowroom
  } = services || {};

  const addressFormatted = `${street}, ${city}, ${state} ${postalCode}`;
  const bingURL = `https://www.bing.com/mapspreview?where1=${addressFormatted}&amp;sty=c`;

  return (
    <Card>
      <CardTitle
        header={(
          <a href={storeDetailsPageLink}>
            <span>{name}</span>
            <span>{"\u00A0"}#{storeId}</span>
          </a>
        )}
        headerVariant="h5"
        action={(
          <span
            aria-label="close overlay button"
            data-id="js-store-overlay-close-button"
            className="sui-text-brand sui-cursor-pointer sui-p-1 sui-mb-1 sui-ml-1"
          >
            <Close
              className="sui-w-3 sui-h-3"
              data-id="js-store-overlay-close-button"
              data-testid="js-store-overlay-close-button"
              color="current"
            />
          </span>
        )}
      />
      <div className="sui-p-1 sui-leading-6">
        <div>{street}</div>
        <div>{`${city}, ${state} ${postalCode}`}</div>
      </div>
      <CardBody>
        <div className="sui-flex">
          <div className="sui-w-6/12">
            <span className="sui-font-bold sui-p-1 sui-block">
              Store Hours
            </span>
            <StoreOverlayHours store={store} />
          </div>
          <div className="sui-w-6/12">
            <span className="sui-font-bold sui-p-1 sui-block">Services</span>
            <div className="sui-pb-2 sui-h-fit">
              <ul className="sui-leading-8 sui-pl-5 sui-list-disc">
                {loadNGo && <li>Load and Go</li>}
                {propane && <li>Propane Exchange</li>}
                {toolRental && <li>Tool Rental Center</li>}
                {penske && <li>Penske Truck Rental</li>}
                {keyCutting && <li>Key Cutting</li>}
                {wiFi && <li>Free WiFi</li>}
                {applianceShowroom && <li>Appliance Showroom</li>}
                {expandedFlooringShowroom && <li>Expanded Floor Showroom</li>}
                {largeEquipment && <li>Large Equipment Rental</li>}
                {kitchenShowroom && <li>Kitchen Showroom</li>}
              </ul>
            </div>
          </div>
        </div>
        <div className="sui-leading-6 sui-p-1 sui-text-info">
          <a href={bingURL} rel="nofollow noreferrer" target="_blank">Directions</a>
        </div>
      </CardBody>
    </Card>
  );
};

StoreOverlay.propTypes = {
  store: storeShape.isRequired
};

StoreOverlay.displayName = 'StoreOverlay';
